export default __webpack_public_path__ + "static/qaser-platform-26b12e0cc22a93c4bb87aebba405f82f.png";